var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrationSecretKeys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 12.75C33 18.1348 28.6348 22.5 23.25 22.5C22.1256 22.5 21.0456 22.3097 20.0406 21.9594L17.3787 24.6213C16.8161 25.184 16.053 25.5 15.2574 25.5H14.25C13.8358 25.5 13.5 25.8358 13.5 26.25V27.2574C13.5 28.053 13.1839 28.816 12.6213 29.3787L11.3787 30.6213C10.8161 31.184 10.053 31.5 9.25735 31.5H6C5.17158 31.5 4.5 30.8284 4.5 30V26.7426C4.5 25.947 4.81606 25.184 5.37868 24.6213L14.0406 15.9594C13.6903 14.9544 13.5 13.8744 13.5 12.75C13.5 7.36522 17.8652 3 23.25 3C28.6348 3 33 7.36522 33 12.75ZM25.5 12.75C25.5 13.9926 24.4926 15 23.25 15C22.0074 15 21 13.9926 21 12.75C21 11.5074 22.0074 10.5 23.25 10.5C24.4926 10.5 25.5 11.5074 25.5 12.75Z",
    fill: "#171717",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationSecretKeys);
export default __webpack_public_path__ + "static/media/integration-secret-keys.46adea9496d08451ba926423ff929249.svg";
export { ForwardRef as ReactComponent };